import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario1PivBadgeAudioCaching, scenario1PivBadgeVideoSegments } from "../../../scenario1-piv-badge";
import { PivBadgeComponentsStep2ComponentMainConfig, PivBadgeComponentsStep2ComponentPart1Config } from "../piv-badge-components-step2";

export default class PivBadgeComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): PivBadgeComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: PivBadgeComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			isYesCorrect: true,
			audioUrl: scenario1PivBadgeAudioCaching.getItemByKey(scenario1PivBadgeAudioCaching.audioKeys.question5).src,
			correctFeedback: `
				<p class="default-text">Correct. Within the last 6 months there was a previous occurrence of 
				this type of event / behavior, and you may consider the “repeated occurrences algorithm” 
				in handling the response with Laura in this event.</p>
			`,
			wrongFeedback: `
				<p class="default-text">Not the best option. There is a history involving this type of 
				behavior or decision making with this employee. The repetitive occurrences section of the 
				decision support tool should be reviewed and considered prior to making your decision.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario1PivBadgeVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, process.env.PUBLIC_URL + '/assets/images/scenarios/step2-image.png', mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		},4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 1 - PIV Badge',
			recapFirst: 'In summary this is “At Risk Behavior.”',
			htmlData: `
				<br/><li>The substitution test is NOT satisfied. <br/><br/></li><li>
				Accountability lies solely with the employee in this instance. <br/><br/></li><li>There is a history 
				involving this type of behavior with this employee. <br/><br/></li><li>The repetitive behavior section 
				of the Decision Support Tool should be reviewed prior to making your final decision.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario1PivBadgeVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario1PivBadgeVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}